import { jsx as t } from "react/jsx-runtime";
function l(i) {
  return /* @__PURE__ */ t("svg", { fill: "none", height: "6", viewBox: "0 0 7 6", width: "7", xmlns: "http://www.w3.org/2000/svg", ...i, children: /* @__PURE__ */ t(
    "path",
    {
      d: "M0.799766 3.46V2.08H2.74377V0.0639999H4.25577V2.08H6.18777V3.46H4.25577V5.452H2.74377V3.46H0.799766Z",
      fill: "#9DAFBD"
    }
  ) });
}
export {
  l as default
};
